import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import CloseMenu from "@assets/svg/closeMenu.svg?react";

import BookingLogo from "@assets/svg/BookingLogo.svg?react";
import GatherInSoon from "@assets/svg/GatherInSoon.svg?react";
import AgodSoon from "@assets/svg/AgodSoon.svg?react";
import ExpediaSoon from "@assets/svg/ExpediaSoon.svg?react";

import useBreakPoinst from "@hooks/useBreakPoinst";
import { useTranslation } from "react-i18next";
import {
  ModalWrapper,
  CloseButtonWrapper,
  CloseMenuIcon,
  CardContainer,
  ChannelGrid,
  ContentBox,
  Title,
  Description,
  ActionContainer,
  StyledButton,
} from "./styles/NewChannelModal";
import ChannelCard from "./ChannelCard";

const NewChannelModal = ({ handleNextModal, onCLose = () => {} }: any) => {
  const navigate = useNavigate();
  const { isPhone } = useBreakPoinst();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onCLose();
  };
  const channels = [
    {
      name: "booking.com",
      icon: <BookingLogo width={28} height={28} />,
    },
    { name: "Gathern", icon: <GatherInSoon width={28} height={28} /> },
    { name: "Agoda", icon: <AgodSoon width={28} height={28} /> },
    { name: "Expedia", icon: <ExpediaSoon width={28} height={28} /> },
  ];

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <ModalWrapper $isPhone={isPhone} $lang={language}>
          <CloseButtonWrapper $isPhone={isPhone} onClick={handleClose}>
            <CloseMenuIcon $isPhone={isPhone}>
              <CloseMenu />
            </CloseMenuIcon>
          </CloseButtonWrapper>
          {/* card container  */}
          <CardContainer $isPhone={isPhone}>
            <ContentBox $isPhone={isPhone}>
              <Title $isPhone={isPhone}>
                {t("onBoardingJourny.increasePropertyReach")}
              </Title>
              <Description $isPhone={isPhone}>
                {t("onBoardingJourny.selectPlatformToConnect")}
              </Description>
            </ContentBox>
            <ChannelGrid $isPhone={isPhone}>
              {channels.map((channel, idx) => (
                <ChannelCard
                  key={channel.name}
                  icon={channel.icon}
                  name={channel.name}
                  soon={idx !== 0 && idx !== 1}
                  selected={idx === 0}
                />
              ))}
            </ChannelGrid>
          </CardContainer>

          <ActionContainer $isPhone={isPhone}>
            <StyledButton
              onClick={() => {
                setOpen(false);
                handleNextModal();
                onCLose();
              }}
              $TextColor="white"
              $BgColor="#5B3FFF"
              $isPhone={isPhone}
              $width="127px"
            >
              {t("onBoardingJourny.connectAccount")}
            </StyledButton>
            <StyledButton
              onClick={() => {
                setOpen(false);
              }}
              $TextColor="#5B3FFF"
              $isPhone={isPhone}
              $BgColor="white"
              $width="85px"
            >
              {t("onBoardingJourny.skip")}
            </StyledButton>
          </ActionContainer>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default NewChannelModal;
